import { Icon } from "@keydials/dial-workspace";

/**
 * Why a sharing form isn't here (KEY-556): shown in place of a form the organisation's share policy would
 * refuse, so a dial admin reads the reason where they came to act instead of filling in something that
 * can't succeed. Text comes from `shareRefusal` in `grantFeedback.ts`.
 */
export function ShareRefusalNote({ text }: { text: string }) {
  return (
    <div
      role="note"
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
        padding: "10px 12px",
        borderRadius: "var(--radius-sm)",
        background: "var(--surface-inset)",
        color: "var(--text-muted)",
        fontSize: 13,
        lineHeight: 1.5,
      }}
    >
      <span style={{ flex: "none", marginTop: 1, display: "flex" }}>
        <Icon name="lock" size={15} />
      </span>
      <span>{text}</span>
    </div>
  );
}
